const SvgArrowTopLong = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="m29.333 13.336-.941.942L16.669 2.552l.054 29.446-1.331.002-.054-29.454L3.609 14.278l-.941-.942L16.001 0z" />
  </svg>;
export default SvgArrowTopLong;